module.exports = __webpack_public_path__ + "img/vip-bg.cb1a13ba.png";